/*
  Kaufabschluss im TeeInBlue-Personalisierer auf denselben Weg bringen wie im
  eigenen Konfigurator: der Hauptknopf fuehrt direkt in die Kasse, der
  Warenkorb steht als Nebenweg darunter.

  Grundsatz, an dem sich alles Weitere ausrichtet: den Warenkorb-Aufruf macht
  weiterhin ausschliesslich TeeInBlue. Hier entsteht kein eigener
  /cart/add.js-Aufruf, es wird kein Feld gelesen, kein Wert gesetzt und nichts
  am Formular veraendert - wir beschriften den vorhandenen Knopf um, haengen
  einen zweiten Weg darunter und sehen zu, ob der Aufruf der App durchging.
  Warenkorb-Paritaet ist damit nicht geprueft, sondern bauartbedingt.
*/
(function () {
  'use strict';

  var AKTIONEN_SEL = '#teeFormActions';
  var ATC_SEL = '.tee-btn--atc';
  var FORM_SEL = '#teeinblue-form';
  var LINK_KL = 'paws-tib-cartlink';
  var VORHANG_KL = 'paws-tib-zurkasse';
  var BUSY_KL = 'paws-tib-busy';

  /*
    Kommt der Kunde mit der Zurueck-Taste aus der Kasse, liegt seine
    Konfiguration bereits im Warenkorb. Ein zweiter Klick auf den Kaufknopf
    darf sie kein zweites Mal hinzufuegen - er fuehrt dann direkt in die Kasse.
    Dieselbe Notiz wie im eigenen Konfigurator, nur unter eigenem Schluessel.
  */
  var KAUF_SPEICHER = 'pawsTibImWarenkorb';

  /*
    Die Notiz gilt nur fuer diese Sitzung und nicht unbegrenzt: wer eine Stunde
    spaeter auf denselben Tab zurueckkommt, hat den Warenkorb laengst
    vergessen. Die Frist ersetzt hier die Konfigurations-Signatur des eigenen
    Konfigurators - siehe vielleichtVergessen().
  */
  var NOTIZ_FRIST_MS = 30 * 60 * 1000;

  var TAKT_MS = 200;
  var SUCH_TAKT_MS = 300;
  var SUCH_LAEUFE = 60;

  /*
    Nach einem Klick auf den Kaufknopf gilt der naechste erfolgreiche
    /cart/add.js als dessen Antwort. Unbegrenzt darf das nicht gelten: ein
    spaeterer Warenkorb-Aufruf aus ganz anderer Quelle - ein Upsell im
    Warenkorb-Vorhang etwa - wuerde sonst eine Weiterleitung ausloesen, die
    niemand angefordert hat.
  */
  var FENSTER_MS = 30000;

  /*
    TeeInBlue meldet nach dem Warenkorb-Aufruf die Zuordnung der
    Personalisierung zum Warenkorb-Token nach (PUT .../cart-token). Reisst
    unsere Weiterleitung diesen Aufruf ab, fehlen der Bestellung die
    Kundendaten. Darauf wird gewartet - aber nie unbegrenzt, denn eine
    haengende Weiterleitung kostet den Kauf ebenso.
  */
  var TOKEN_WARTEN_MS = 2500;
  var TOKEN_GRENZE_MS = 6000;

  /*
    Ladezustand und Vorhang beginnen mit dem Klick, nicht erst mit der Antwort
    des Warenkorb-Aufrufs - sonst faehrt die Warenkorb-Lade im selben Moment
    auf, in dem wir sie verstecken wollen, und der Kunde sieht sie aufblitzen.

    Das hat einen Preis: faellt die Pflichtpruefung der App durch, kommt gar
    kein Warenkorb-Aufruf. Dann muessen Ladezustand und Vorhang von selbst
    wieder verschwinden - dafuer die kurze Frist. Sobald der Aufruf tatsaechlich
    laeuft, gilt die lange.
  */
  var RUECKFALL_MS = 3500;
  var NOTAUS_MS = TOKEN_GRENZE_MS + 4000;

  /*
    Schreibt die App die Beschriftung genauso hartnaeckig zurueck, wie wir sie
    setzen, entsteht ein Flackern. Dann lieber aufgeben als flimmern.
  */
  var SCHREIB_GRENZE = 20;

  var texte = {};
  try {
    var quelle = document.querySelector('script[data-paws-kauftexte]');
    texte = JSON.parse((quelle && quelle.getAttribute('data-paws-kauftexte')) || '{}');
  } catch (e) {}
  var TXT_KASSE = texte.checkout || 'Sicher zur Kasse';
  var TXT_WARENKORB = texte.cart || 'oder erst in den Warenkorb legen';
  var TXT_LAEDT = texte.busy || 'Weiter zur Kasse \u2026';
  var TXT_DRIN = texte.drin || 'Weiter zur Kasse';
  var TXT_DRIN_LINK = texte.drin_link || 'oder Warenkorb ansehen';

  var modus = 'checkout';
  var naechsterWegWarenkorb = false;
  var geklicktUm = 0;
  // Bleibt nach dem Kauf stehen (anders als geklicktUm) - daran erkennt
  // zeileMerken, ob ein Warenkorb-Aufruf ueberhaupt von diesem Knopf kam.
  var letzterKlickUm = 0;
  var erfolgGemeldetUm = 0;
  var letzterKlickWeg = 'checkout';
  var imKauf = false;
  var springtSchon = false;
  var notausId = null;
  var vorhangId = null;
  var abgeschaltet = false;

  var tokenOffen = 0;
  var tokenGesehen = false;

  // { schluessel, seite, zeit } - solange gesetzt, liegt die Konfiguration
  // unveraendert im Warenkorb.
  var imWarenkorb = null;

  var beobachter = null;
  var geplant = null;
  var schreibFenster = 0;
  var schreibZaehler = 0;

  function nichts() {}

  function shopWurzel() {
    var w = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return w.charAt(w.length - 1) === '/' ? w : w + '/';
  }

  function melden(name, zusatz) {
    var nutzlast = { configurator: 'teeinblue', step_id: 'tib_atc' };
    for (var k in zusatz) {
      if (Object.prototype.hasOwnProperty.call(zusatz, k)) nutzlast[k] = zusatz[k];
    }
    try {
      if (window.pawsInsights && window.pawsInsights.track) {
        window.pawsInsights.track(name, nutzlast);
      } else {
        window.pawsInsightsQueue = window.pawsInsightsQueue || [];
        window.pawsInsightsQueue.push([name, nutzlast]);
      }
    } catch (e) {}
  }

  function atcKnopf() {
    return document.querySelector(AKTIONEN_SEL + ' ' + ATC_SEL);
  }

  // Die App legt den Text in ein <span>; fehlt es, traegt ihn der Knopf selbst.
  function beschriftung(knopf) {
    return knopf.querySelector('span') || knopf;
  }

  /* -------------------------------------------------------------------- */
  /* Notiz: liegt diese Konfiguration schon im Warenkorb?                  */
  /* -------------------------------------------------------------------- */

  /*
    Der eigene Konfigurator vergleicht dafuer eine Signatur ueber alle
    Formularfelder. Hier geht das nicht: das Formular gehoert der App, sie baut
    es laufend neu auf und vergibt dabei neue Namen und Kennungen - eine
    Signatur darueber waere mal zu streng, mal zu lasch.

    Stattdessen zaehlt, was der Kunde tut: jede echte Eingabe im Konfigurator
    verwirft die Notiz (vielleichtVergessen), und beim Laden wird sie gegen den
    tatsaechlichen Warenkorb geprueft (warenkorbAbgleichen). Nur wenn beides
    zusammenpasst, gilt die Konfiguration als bereits gekauft.
  */
  function seitenKennung() {
    var variante = '';
    try { variante = new URLSearchParams(location.search).get('variant') || ''; } catch (e) {}
    return location.pathname + '#' + variante;
  }

  function notizLesen() {
    var notiz = null;
    try { notiz = JSON.parse(sessionStorage.getItem(KAUF_SPEICHER) || 'null'); } catch (e) {}
    if (!notiz || !notiz.schluessel) return null;
    if (notiz.seite !== seitenKennung()) return null;
    if (!notiz.zeit || Date.now() - notiz.zeit > NOTIZ_FRIST_MS) return null;
    return notiz;
  }

  function merkeKauf(schluessel) {
    if (!schluessel) return;
    imWarenkorb = { schluessel: schluessel, seite: seitenKennung(), zeit: Date.now() };
    try { sessionStorage.setItem(KAUF_SPEICHER, JSON.stringify(imWarenkorb)); } catch (e) {}
  }

  function vergissKauf() {
    imWarenkorb = null;
    try { sessionStorage.removeItem(KAUF_SPEICHER); } catch (e) {}
    aufbauen();
  }

  /*
    Die Antwort von /cart/add.js ist die neu angelegte Warenkorbzeile selbst
    (aeltere Aufrufe liefern stattdessen {items: [...]}). Ihr Schluessel ist
    das Einzige, was wir uns merken - der Inhalt der Zeile bleibt Sache der App.

    Nur die eigene Zeile: ein Zusatzprodukt, das der Kunde gleich darauf in der
    Warenkorb-Lade hinzufuegt, laeuft ueber denselben Aufruf. Wuerde die Notiz
    darauf zeigen, verfiele sie mit dem Entfernen des Zusatzprodukts - und das
    personalisierte Produkt landete ein zweites Mal im Warenkorb.
  */
  function zeileMerken(daten) {
    if (imWarenkorb) return;
    if (!letzterKlickUm || Date.now() - letzterKlickUm > FENSTER_MS) return;
    try {
      var d = typeof daten === 'string' ? JSON.parse(daten) : daten;
      if (!d) return;
      var zeile = d.key ? d : (d.items && d.items.length ? d.items[d.items.length - 1] : null);
      if (zeile && zeile.key) merkeKauf(zeile.key);
    } catch (e) {}
  }

  /*
    In der Kasse kann die Zeile geloescht worden sein - dann zaehlt die Notiz
    nicht mehr. Faellt die Abfrage aus, bleibt die Notiz stehen: ein doppelter
    Kauf waere teurer als ein Umweg ueber den Warenkorb.
  */
  function warenkorbAbgleichen() {
    var notiz = notizLesen();
    imWarenkorb = notiz;
    aufbauen();
    if (!notiz || typeof window.fetch !== 'function') return;
    window.fetch(shopWurzel() + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) {
      return r && r.ok ? r.json() : null;
    }).then(function (korb) {
      if (!korb || !korb.items) return;
      var drin = false;
      for (var i = 0; i < korb.items.length; i++) {
        if (korb.items[i].key === notiz.schluessel) { drin = true; break; }
      }
      if (!drin) vergissKauf();
    }, nichts);
  }

  /*
    Sobald der Kunde etwas am Konfigurator aendert, ist es nicht mehr dasselbe
    Produkt - auch eine geaenderte Menge nicht. Nur die beiden Kaufwege selbst
    aendern nichts.

    `isTrusted` trennt dabei den Kunden von der App: TeeInBlue stellt beim
    Laden die zuletzt gewaehlte Konfiguration wieder her und loest dabei eigene
    Klicks aus. Wuerden die zaehlen, waere die Notiz sofort wieder wertlos.
  */
  function vielleichtVergessen(e) {
    if (!imWarenkorb || !e || !e.isTrusted) return;
    var z = e.target;
    if (!z || !z.closest) return;
    if (z.closest(AKTIONEN_SEL + ' ' + ATC_SEL) || z.closest('.' + LINK_KL)) return;
    if (!z.closest(FORM_SEL) && !z.closest(AKTIONEN_SEL)) return;
    vergissKauf();
  }

  document.addEventListener('click', vielleichtVergessen, true);
  document.addEventListener('change', vielleichtVergessen, true);
  document.addEventListener('input', vielleichtVergessen, true);

  /*
    Die Warenkorb-Lade von UpCart, sonst die des Themes - eine eigene Seite ist
    der Notnagel. Gleiches Vorgehen wie im eigenen Konfigurator: nach dem
    Zurueck aus der Kasse meldet sich UpCart erst kurz nach dem Laden.
  */
  function warenkorbOeffnen(versuch) {
    var runde = versuch || 0;
    if (typeof window.upcartOpenCart !== 'function') {
      if (runde < 8) {
        setTimeout(function () { warenkorbOeffnen(runde + 1); }, 100);
        return;
      }
      var schalter = document.querySelector('[aria-controls="CartDrawer"]');
      if (schalter) schalter.click();
      else window.location.assign(shopWurzel() + 'cart');
      return;
    }
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      window.upcartOpenCart();
    } catch (e) {}
  }

  /* -------------------------------------------------------------------- */
  /* Beschriftung und Nebenweg                                             */
  /* -------------------------------------------------------------------- */

  function textPflegen() {
    if (abgeschaltet) return;
    var knopf = atcKnopf();
    if (!knopf) return;
    var traeger = beschriftung(knopf);
    // Waehrend des Kaufs traegt derselbe Knopf den Ladezustand. Zeichnet die
    // App ihn zwischendurch neu, wird auch der wiederhergestellt - sonst stuende
    // dort mitten im Vorgang wieder "In den Warenkorb".
    // Liegt die Konfiguration schon im Warenkorb, sagt der Knopf genau das,
    // was er dann tut: weiter zur Kasse, ohne noch einmal hinzuzufuegen.
    var soll = imKauf ? TXT_LAEDT : (imWarenkorb ? TXT_DRIN : TXT_KASSE);
    if (knopf.classList.contains(BUSY_KL) !== imKauf) knopf.classList.toggle(BUSY_KL, imKauf);
    if (imKauf) {
      if (knopf.getAttribute('aria-busy') !== 'true') knopf.setAttribute('aria-busy', 'true');
    } else if (knopf.hasAttribute('aria-busy')) {
      knopf.removeAttribute('aria-busy');
    }
    if (traeger.textContent === soll) return;

    var jetzt = Date.now();
    if (jetzt - schreibFenster > 1000) {
      schreibFenster = jetzt;
      schreibZaehler = 0;
    }
    if (++schreibZaehler > SCHREIB_GRENZE) {
      abgeschaltet = true;
      if (beobachter) beobachter.disconnect();
      return;
    }
    traeger.textContent = soll;
  }

  /* -------------------------------------------------------------------- */
  /* Vorhang, Ladezustand und das Zuruecknehmen von beidem                 */
  /* -------------------------------------------------------------------- */

  /*
    Die Warenkorb-Lade von UpCart haengt im Schattenbaum von #upCart - an ihre
    Innereien kommt keine Regel dieser Seite heran. `display: none` auf dem
    Wirtselement blendet den ganzen Schattenbaum aus; nachgemessen faellt damit
    auch die Sperre des Seiten-Scrollens weg.
  */
  function vorhangAn() {
    if (vorhangId) { clearTimeout(vorhangId); vorhangId = null; }
    document.documentElement.classList.add(VORHANG_KL);
  }

  function vorhangAus() {
    if (vorhangId) return;
    /*
      Erst die Lade schliessen, dann den Vorhang heben. Andersherum saehe der
      Kunde sie erst auffahren und dann wieder zu - genau das, was er beim
      Zurueckkommen aus der Kasse beschrieben hat.
    */
    ladeSchliessen();
    vorhangId = setTimeout(function () {
      vorhangId = null;
      document.documentElement.classList.remove(VORHANG_KL);
    }, 400);
  }

  function ladeSchliessen() {
    try {
      if (document.body.classList.contains('upcartPopupShow') &&
          typeof window.upcartCloseCart === 'function') {
        window.upcartCloseCart();
      }
    } catch (e) {}
  }

  function notausSetzen(ms) {
    if (notausId) clearTimeout(notausId);
    notausId = setTimeout(function () {
      notausId = null;
      zuruecksetzen();
    }, ms);
  }

  /*
    Ein Weg zurueck in den Ruhezustand, der von ueberall gilt: nach einer
    abgebrochenen Pflichtpruefung, nach einer ausgebliebenen Weiterleitung und
    vor allem beim Zurueckkommen aus der Kasse. Ohne dieses Zuruecksetzen blieb
    `imKauf` gesetzt, die Beschriftung wurde nicht mehr gepflegt, der Vorhang
    fiel erst nach Ablauf des Notaus - und dahinter stand die laengst geoeffnete
    Warenkorb-Lade samt gesperrtem Scrollen.
  */
  function zuruecksetzen() {
    if (notausId) { clearTimeout(notausId); notausId = null; }
    imKauf = false;
    springtSchon = false;
    geklicktUm = 0;
    naechsterWegWarenkorb = false;
    modus = 'checkout';
    schreibFenster = 0;
    schreibZaehler = 0;
    vorhangAus();
    aufbauen();
  }

  function nebenwegSetzen() {
    var knopf = atcKnopf();
    if (!knopf) return false;
    var aktionen = knopf.closest(AKTIONEN_SEL);
    if (!aktionen) return false;

    var link = document.querySelector('.' + LINK_KL);
    if (!link) {
      link = document.createElement('button');
      link.type = 'button';
      link.className = LINK_KL;
      link.addEventListener('click', warenkorbWeg);
    }
    // Liegt die Konfiguration schon im Warenkorb, fuehrt der Nebenweg nicht
    // mehr hinein, sondern nur noch hin - die Beschriftung sagt es.
    var linkText = imWarenkorb ? TXT_DRIN_LINK : TXT_WARENKORB;
    if (link.textContent !== linkText) link.textContent = linkText;
    /*
      Wie bei den Vorteilen darunter: eigene Knoten hinter den Block der App
      haengen, nicht hinein - Vue vergleicht seine eigenen Kinder. Die Vorteile
      aus assets/tib-redesign.js setzen sich je nach Ladereihenfolge an
      dieselbe Stelle; der Nebenweg gehoert direkt unter den Kaufknopf, also
      wird die Position nachgezogen - geschrieben nur, wenn sie nicht stimmt.
    */
    if (aktionen.nextElementSibling !== link) aktionen.insertAdjacentElement('afterend', link);
    raenderAngleichen(link, aktionen);
    bewertungenSetzen(link);
    return true;
  }

  /*
    Die Kundenstimmen liegen fertig gerendert in #paws-fr-quelle (siehe
    sections/ext-main-product.liquid) und werden hier hinter den Nebenweg
    gezogen. Damit steht unter dem Kaufknopf dieselbe Reihenfolge wie im
    eigenen Konfigurator: Kaufweg, Warenkorb-Link, Kundenstimmen, Vorteile.

    Angehaengt wird am Link, nicht an den Aktionen: nebenwegSetzen() zieht
    den Link jeden Takt auf die Position direkt hinter den Aktionsblock
    zurueck: beide an dieselbe Stelle zu setzen ergaebe ein Hin und Her,
    das nie zur Ruhe kaeme.

    Geschrieben wird nur, wenn die Position nicht stimmt - und es wird
    ausschliesslich die Reihenfolge geprueft, nie eine Groesse. Ein aus
    gemessenen Pixeln abgeleiteter Abstand koennte sich hier selbst
    aufschaukeln.

    Anders als Nebenweg und Kaufknopf uebernimmt der Block bewusst NICHT die
    negativen Seitenabstaende des Aktionsblocks. Die ziehen bis auf einen
    Pixel an den Rahmen der App-Karte heran - fuer eine Flaeche ohne eigene
    Kante egal, fuer diesen Block der Grund, warum er wie eine zweite Karte
    in der ersten aussah. Er bleibt im Textraster.
  */
  function bewertungenSetzen(link) {
    var block = document.querySelector('.paws-fr');
    if (!block) return;
    if (link.nextElementSibling !== block) link.insertAdjacentElement('afterend', block);
  }

  /*
    Der Aktionsblock der App bringt eigene Aussenabstaende mit (gemessen:
    seitlich -10px, unten 15px). Beides wird von dort uebernommen statt
    geraten: seitlich, damit der Nebenweg an denselben Kanten steht wie
    Mengenauswahl und Kaufknopf, oben, damit er dicht darunter sitzt.
  */
  function raenderAngleichen(link, aktionen) {
    var s = window.getComputedStyle(aktionen);
    var unten = parseFloat(s.marginBottom) || 0;
    var oben = unten ? -unten + 'px' : '0px';
    var rand = (parseFloat(s.marginLeft) || 0) + (parseFloat(s.marginRight) || 0) + 'px';
    if (link.style.marginTop !== oben) link.style.marginTop = oben;
    if (link.style.marginLeft !== s.marginLeft) link.style.marginLeft = s.marginLeft;
    if (link.style.marginRight !== s.marginRight) link.style.marginRight = s.marginRight;
    if (link.style.getPropertyValue('--paws-tib-rand') !== rand) {
      link.style.setProperty('--paws-tib-rand', rand);
    }
  }

  function aufbauen() {
    textPflegen();
    return nebenwegSetzen();
  }

  function warenkorbWeg(e) {
    if (e) e.preventDefault();
    var knopf = atcKnopf();
    if (!knopf) return;
    naechsterWegWarenkorb = true;
    // Bewusst der Knopf der App: Pflichtpruefung, Formular und Warenkorb-Aufruf
    // bleiben unveraendert deren Sache.
    knopf.click();
  }

  /* -------------------------------------------------------------------- */
  /* Kaufweg merken                                                        */
  /* -------------------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest(AKTIONEN_SEL + ' ' + ATC_SEL) : null;
    if (!ziel) return;
    modus = naechsterWegWarenkorb ? 'warenkorb' : 'checkout';
    naechsterWegWarenkorb = false;
    geklicktUm = Date.now();
    letzterKlickUm = geklicktUm;
    letzterKlickWeg = modus;
    // Von assets/paws-insights.js gelesen, damit im Trichter derselbe
    // Parameter steht wie beim eigenen Konfigurator.
    window.PAWS_TIB_KAUFWEG = modus;

    /*
      Zurueck aus der Kasse: die unveraenderte Konfiguration liegt schon im
      Warenkorb. Der Klick der App wird hier abgefangen, bevor er sie erreicht
      - sonst entstuende eine zweite Warenkorbzeile mit demselben Produkt.
      `stopImmediatePropagation` haelt auch die Trichter-Meldung zurueck: es
      wird nichts hinzugefuegt, also darf auch kein Hinzufuegen gemeldet werden.
    */
    if (imWarenkorb && !imKauf && !abgeschaltet) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      geklicktUm = 0;
      erneutKaufen(modus);
      return;
    }

    // Der Nebenweg fuehrt bewusst in die Warenkorb-Lade - dort bleibt alles
    // wie zuvor.
    if (modus !== 'checkout' || imKauf || abgeschaltet) return;
    imKauf = true;
    textPflegen();
    vorhangAn();
    notausSetzen(RUECKFALL_MS);
  }, true);

  /*
    Kein zweiter Warenkorb-Aufruf, nur noch der Weg zum Ziel: in die Kasse
    (Hauptknopf) oder in die Warenkorb-Lade (Nebenweg).
  */
  function erneutKaufen(weg) {
    if (weg !== 'checkout') {
      warenkorbOeffnen();
      return;
    }
    imKauf = true;
    textPflegen();
    vorhangAn();
    // Bleibt die Weiterleitung wider Erwarten aus, darf der Warenkorb nicht
    // dauerhaft unsichtbar sein.
    notausSetzen(NOTAUS_MS);
    springen(true);
  }

  /* -------------------------------------------------------------------- */
  /* Zusehen, ob der Aufruf der App durchging                              */
  /* -------------------------------------------------------------------- */

  function pfadVon(eingabe) {
    var roh = '';
    try {
      roh = (eingabe && typeof eingabe === 'object' && eingabe.url) ? eingabe.url : String(eingabe || '');
    } catch (e) {
      return '';
    }
    return roh.split('#')[0].split('?')[0];
  }

  function tokenFertig() {
    if (tokenOffen > 0) tokenOffen--;
  }

  function istAdd(pfad) {
    return /\/cart\/add(\.js)?$/.test(pfad);
  }

  function istToken(pfad) {
    return /cart-token/.test(pfad);
  }

  function erfolgMelden() {
    if (!letzterKlickUm || Date.now() - letzterKlickUm > FENSTER_MS) return;
    if (erfolgGemeldetUm === letzterKlickUm) return;
    erfolgGemeldetUm = letzterKlickUm;
    melden('configurator_add_to_cart_success', { kauf_weg: letzterKlickWeg });
  }

  function fetchBeobachten() {
    if (typeof window.fetch !== 'function') return;
    var original = window.fetch;
    window.fetch = function () {
      var antwort = original.apply(this, arguments);
      try {
        var pfad = pfadVon(arguments[0]);
        if (istAdd(pfad)) {
          aufrufBegonnen();
          // Beide Zweige belegen: ein abgelehntes Versprechen ohne
          // Fehlerzweig gilt sonst als unbehandelt.
          antwort.then(function (r) {
            if (!r || !r.ok) return;
            // Der Klon, weil die App den Rumpf selbst noch liest.
            try { r.clone().json().then(zeileMerken, nichts); } catch (e2) {}
            erfolgMelden();
            hinzugefuegt();
          }, nichts);
        } else if (istToken(pfad)) {
          tokenGesehen = true;
          tokenOffen++;
          antwort.then(tokenFertig, tokenFertig);
        }
      } catch (e) {}
      return antwort;
    };
  }

  /*
    Welchen Transportweg die App waehlt, ist ihre Sache und kann sich mit dem
    naechsten App-Update aendern. Beide Wege werden beobachtet, damit die
    Wartezeit vor der Weiterleitung nicht stillschweigend wirkungslos wird.
  */
  function xhrBeobachten() {
    var X = window.XMLHttpRequest;
    if (typeof X !== 'function' || !X.prototype || !X.prototype.open) return;
    var oeffnen = X.prototype.open;
    var senden = X.prototype.send;
    X.prototype.open = function (methode, adresse) {
      try { this.__pawsPfad = pfadVon(adresse); } catch (e) {}
      return oeffnen.apply(this, arguments);
    };
    X.prototype.send = function () {
      try {
        var pfad = this.__pawsPfad || '';
        if (istAdd(pfad)) {
          aufrufBegonnen();
          this.addEventListener('load', function () {
            if (this.status < 200 || this.status >= 300) return;
            try { zeileMerken(this.responseText); } catch (e2) {}
            erfolgMelden();
            hinzugefuegt();
          });
        } else if (istToken(pfad)) {
          tokenGesehen = true;
          tokenOffen++;
          // loadend deckt Erfolg, Fehler und Abbruch gleichermassen ab.
          this.addEventListener('loadend', tokenFertig);
        }
      } catch (e) {}
      return senden.apply(this, arguments);
    };
  }

  function netzBeobachten() {
    if (window.__pawsTibKaufBeobachtet) return;
    window.__pawsTibKaufBeobachtet = true;
    fetchBeobachten();
    xhrBeobachten();
  }

  /*
    Laeuft der Warenkorb-Aufruf, ist die Pflichtpruefung der App durch - die
    kurze Rueckfallfrist waere jetzt zu knapp. Ab hier deckt die Frist die
    Wartezeit auf den Token-Nachtrag mit ab.
  */
  function aufrufBegonnen() {
    if (modus !== 'checkout' || !imKauf) return;
    notausSetzen(NOTAUS_MS);
  }

  function hinzugefuegt() {
    if (modus !== 'checkout' || springtSchon) return;
    if (!geklicktUm || Date.now() - geklicktUm > FENSTER_MS) return;
    geklicktUm = 0;
    springtSchon = true;

    /*
      Entscheidend: nur ein Token-Aufruf, der NACH diesem Warenkorb-Aufruf
      beginnt, gehoert zu diesem Kauf. Ohne dieses Zuruecksetzen wuerde ein
      frueherer, laengst abgeschlossener Aufruf die Wartebedingung sofort
      erfuellen - und die Weiterleitung risse den eigentlichen Aufruf ab.
    */
    tokenGesehen = false;

    // Beides steht seit dem Klick. Erneut setzen kostet nichts und faengt den
    // Fall ab, dass der Kauf ohne unseren Klick zustande kam.
    imKauf = true;
    textPflegen();
    vorhangAn();
    // Bleibt die Weiterleitung wider Erwarten aus, darf der Warenkorb nicht
    // dauerhaft unsichtbar sein.
    notausSetzen(NOTAUS_MS);

    warten(Date.now());
  }

  function warten(start) {
    var alter = Date.now() - start;
    var bereit = tokenOffen === 0 && (tokenGesehen || alter >= TOKEN_WARTEN_MS);
    if (bereit || alter >= TOKEN_GRENZE_MS) {
      springen();
      return;
    }
    setTimeout(function () { warten(start); }, 100);
  }

  function springen(erneut) {
    var zusatz = { kauf_weg: 'checkout' };
    // Getrennt auswertbar: dieser Sprung fuehrt ohne neuen Warenkorb-Aufruf in
    // die Kasse, weil die Konfiguration schon darin liegt.
    if (erneut) zusatz.erneut = true;
    melden('configurator_checkout_redirect', zusatz);
    window.location.assign(shopWurzel() + 'checkout');
  }

  /* -------------------------------------------------------------------- */
  /* Beobachtung                                                           */
  /* -------------------------------------------------------------------- */

  function planen() {
    if (geplant || abgeschaltet) return;
    geplant = setTimeout(function () {
      geplant = null;
      aufbauen();
    }, TAKT_MS);
  }

  function beobachtungsWurzel() {
    var knopf = atcKnopf();
    var aktionen = knopf && knopf.closest(AKTIONEN_SEL);
    return (aktionen && aktionen.closest('.tee-form-wrapper')) ||
      (aktionen && aktionen.parentElement) ||
      document.getElementById('teeinblue-form');
  }

  function beobachten() {
    if (typeof MutationObserver !== 'function') return;
    if (!beobachter) {
      var wurzel = beobachtungsWurzel();
      if (!wurzel) return;
      beobachter = new MutationObserver(function () {
        // Synchron, damit die alte Beschriftung nach einem Neuaufbau nicht
        // sichtbar wird; der Rest laeuft gedrosselt.
        textPflegen();
        planen();
      });
      beobachter.observe(wurzel, { childList: true, subtree: true, characterData: true });
    }
  }

  function starten() {
    netzBeobachten();
    warenkorbAbgleichen();
    var laeufe = 0;
    var suche = setInterval(function () {
      laeufe++;
      var da = aufbauen();
      if (da) beobachten();
      if ((da && beobachter) || laeufe >= SUCH_LAEUFE) clearInterval(suche);
    }, SUCH_TAKT_MS);
    aufbauen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  /*
    Zurueck aus der Kasse: der Browser stellt die Seite aus dem Zwischenspeicher
    genau so wieder her, wie sie beim Verlassen war - mit stehendem Vorhang,
    ladendem Knopf und der offenen, nur verdeckten Warenkorb-Lade. Auch die
    laufenden Fristen setzen erst dort fort, wo sie eingefroren wurden. Ohne
    dieses Aufraeumen bleibt die Seite scheinbar eingefroren, und nach einigen
    Sekunden steht ploetzlich die Warenkorb-Lade offen.
  */
  window.addEventListener('pageshow', function () {
    zuruecksetzen();
    // Aus dem Zwischenspeicher wiederhergestellte Seiten laufen nicht neu an -
    // der Abgleich mit dem Warenkorb muss hier noch einmal von Hand kommen.
    warenkorbAbgleichen();
  });
})();
